{"aXLE6j":[{"type":0,"value":"Mein "},{"type":1,"value":"island"}]}